function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function t(t) {
  for (var n = arguments.length, r = Array(n > 1 ? n - 1 : 0), e = 1; e < n; e++) {
    r[e - 1] = arguments[e];
  }

  if ("production" !== process.env.NODE_ENV) {
    var i = Y[t],
        o = i ? "function" == typeof i ? i.apply(null, r) : i : "unknown error nr: " + t;
    throw Error("[Immer] " + o);
  }

  throw Error("[Immer] minified error nr: " + t + (r.length ? " " + r.map(function (t) {
    return "'" + t + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}

function n(t) {
  return !!t && !!t[Q];
}

function r(t) {
  return !!t && (function (t) {
    if (!t || "object" != _typeof(t)) return !1;
    var n = Object.getPrototypeOf(t);
    return !n || n === Object.prototype;
  }(t) || Array.isArray(t) || !!t[L] || !!t.constructor[L] || s(t) || v(t));
}

function e(r) {
  return n(r) || t(23, r), r[Q].t;
}

function i(t, n, r) {
  void 0 === r && (r = !1), 0 === o(t) ? (r ? Object.keys : Z)(t).forEach(function (e) {
    r && "symbol" == _typeof(e) || n(e, t[e], t);
  }) : t.forEach(function (r, e) {
    return n(e, r, t);
  });
}

function o(t) {
  var n = t[Q];
  return n ? n.i > 3 ? n.i - 4 : n.i : Array.isArray(t) ? 1 : s(t) ? 2 : v(t) ? 3 : 0;
}

function u(t, n) {
  return 2 === o(t) ? t.has(n) : Object.prototype.hasOwnProperty.call(t, n);
}

function a(t, n) {
  return 2 === o(t) ? t.get(n) : t[n];
}

function f(t, n, r) {
  var e = o(t);
  2 === e ? t.set(n, r) : 3 === e ? (t.delete(n), t.add(r)) : t[n] = r;
}

function c(t, n) {
  return t === n ? 0 !== t || 1 / t == 1 / n : t != t && n != n;
}

function s(t) {
  return X && t instanceof Map;
}

function v(t) {
  return q && t instanceof Set;
}

function p(t) {
  return t.o || t.t;
}

function l(t) {
  if (Array.isArray(t)) return Array.prototype.slice.call(t);
  var n = tt(t);
  delete n[Q];

  for (var r = Z(n), e = 0; e < r.length; e++) {
    var i = r[e],
        o = n[i];
    !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (n[i] = {
      configurable: !0,
      writable: !0,
      enumerable: o.enumerable,
      value: t[i]
    });
  }

  return Object.create(Object.getPrototypeOf(t), n);
}

function d(t, e) {
  return void 0 === e && (e = !1), y(t) || n(t) || !r(t) ? t : (o(t) > 1 && (t.set = t.add = t.clear = t.delete = h), Object.freeze(t), e && i(t, function (t, n) {
    return d(n, !0);
  }, !0), t);
}

function h() {
  t(2);
}

function y(t) {
  return null == t || "object" != _typeof(t) || Object.isFrozen(t);
}

function b(n) {
  var r = nt[n];
  return r || t(18, n), r;
}

function m(t, n) {
  nt[t] || (nt[t] = n);
}

function _() {
  return "production" === process.env.NODE_ENV || U || t(0), U;
}

function j(t, n) {
  n && (b("Patches"), t.u = [], t.s = [], t.v = n);
}

function g(t) {
  w(t), t.p.forEach(S), t.p = null;
}

function w(t) {
  t === U && (U = t.l);
}

function O(t) {
  return U = {
    p: [],
    l: U,
    h: t,
    m: !0,
    _: 0
  };
}

function S(t) {
  var n = t[Q];
  0 === n.i || 1 === n.i ? n.j() : n.g = !0;
}

function P(n, e) {
  e._ = e.p.length;
  var i = e.p[0],
      o = void 0 !== n && n !== i;
  return e.h.O || b("ES5").S(e, n, o), o ? (i[Q].P && (g(e), t(4)), r(n) && (n = M(e, n), e.l || x(e, n)), e.u && b("Patches").M(i[Q], n, e.u, e.s)) : n = M(e, i, []), g(e), e.u && e.v(e.u, e.s), n !== H ? n : void 0;
}

function M(t, n, r) {
  if (y(n)) return n;
  var e = n[Q];
  if (!e) return i(n, function (i, o) {
    return A(t, e, n, i, o, r);
  }, !0), n;
  if (e.A !== t) return n;
  if (!e.P) return x(t, e.t, !0), e.t;

  if (!e.I) {
    e.I = !0, e.A._--;
    var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o;
    i(3 === e.i ? new Set(o) : o, function (n, i) {
      return A(t, e, o, n, i, r);
    }), x(t, o, !1), r && t.u && b("Patches").R(e, r, t.u, t.s);
  }

  return e.o;
}

function A(e, i, o, a, c, s) {
  if ("production" !== process.env.NODE_ENV && c === o && t(5), n(c)) {
    var v = M(e, c, s && i && 3 !== i.i && !u(i.D, a) ? s.concat(a) : void 0);
    if (f(o, a, v), !n(v)) return;
    e.m = !1;
  }

  if (r(c) && !y(c)) {
    if (!e.h.N && e._ < 1) return;
    M(e, c), i && i.A.l || x(e, c);
  }
}

function x(t, n, r) {
  void 0 === r && (r = !1), t.h.N && t.m && d(n, r);
}

function z(t, n) {
  var r = t[Q];
  return (r ? p(r) : t)[n];
}

function I(t, n) {
  if (n in t) for (var r = Object.getPrototypeOf(t); r;) {
    var e = Object.getOwnPropertyDescriptor(r, n);
    if (e) return e;
    r = Object.getPrototypeOf(r);
  }
}

function k(t) {
  t.P || (t.P = !0, t.l && k(t.l));
}

function E(t) {
  t.o || (t.o = l(t.t));
}

function R(t, n, r) {
  var e = s(n) ? b("MapSet").T(n, r) : v(n) ? b("MapSet").F(n, r) : t.O ? function (t, n) {
    var r = Array.isArray(t),
        e = {
      i: r ? 1 : 0,
      A: n ? n.A : _(),
      P: !1,
      I: !1,
      D: {},
      l: n,
      t: t,
      k: null,
      o: null,
      j: null,
      C: !1
    },
        i = e,
        o = rt;
    r && (i = [e], o = et);
    var u = Proxy.revocable(i, o),
        a = u.revoke,
        f = u.proxy;
    return e.k = f, e.j = a, f;
  }(n, r) : b("ES5").J(n, r);
  return (r ? r.A : _()).p.push(e), e;
}

function D(e) {
  return n(e) || t(22, e), function t(n) {
    if (!r(n)) return n;
    var e,
        u = n[Q],
        c = o(n);

    if (u) {
      if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
      u.I = !0, e = N(n, c), u.I = !1;
    } else e = N(n, c);

    return i(e, function (n, r) {
      u && a(u.t, n) === r || f(e, n, t(r));
    }), 3 === c ? new Set(e) : e;
  }(e);
}

function N(t, n) {
  switch (n) {
    case 2:
      return new Map(t);

    case 3:
      return Array.from(t);
  }

  return l(t);
}

function T() {
  function r(t, n) {
    var r = s[t];
    return r ? r.enumerable = n : s[t] = r = {
      configurable: !0,
      enumerable: n,
      get: function get() {
        var n = this[Q];
        return "production" !== process.env.NODE_ENV && f(n), rt.get(n, t);
      },
      set: function set(n) {
        var r = this[Q];
        "production" !== process.env.NODE_ENV && f(r), rt.set(r, t, n);
      }
    }, r;
  }

  function e(t) {
    for (var n = t.length - 1; n >= 0; n--) {
      var r = t[n][Q];
      if (!r.P) switch (r.i) {
        case 5:
          a(r) && k(r);
          break;

        case 4:
          o(r) && k(r);
      }
    }
  }

  function o(t) {
    for (var n = t.t, r = t.k, e = Z(r), i = e.length - 1; i >= 0; i--) {
      var o = e[i];

      if (o !== Q) {
        var a = n[o];
        if (void 0 === a && !u(n, o)) return !0;
        var f = r[o],
            s = f && f[Q];
        if (s ? s.t !== a : !c(f, a)) return !0;
      }
    }

    var v = !!n[Q];
    return e.length !== Z(n).length + (v ? 0 : 1);
  }

  function a(t) {
    var n = t.k;
    if (n.length !== t.t.length) return !0;
    var r = Object.getOwnPropertyDescriptor(n, n.length - 1);
    return !(!r || r.get);
  }

  function f(n) {
    n.g && t(3, JSON.stringify(p(n)));
  }

  var s = {};
  m("ES5", {
    J: function J(t, n) {
      var e = Array.isArray(t),
          i = function (t, n) {
        if (t) {
          for (var e = Array(n.length), i = 0; i < n.length; i++) {
            Object.defineProperty(e, "" + i, r(i, !0));
          }

          return e;
        }

        var o = tt(n);
        delete o[Q];

        for (var u = Z(o), a = 0; a < u.length; a++) {
          var f = u[a];
          o[f] = r(f, t || !!o[f].enumerable);
        }

        return Object.create(Object.getPrototypeOf(n), o);
      }(e, t),
          o = {
        i: e ? 5 : 4,
        A: n ? n.A : _(),
        P: !1,
        I: !1,
        D: {},
        l: n,
        t: t,
        k: i,
        o: null,
        g: !1,
        C: !1
      };

      return Object.defineProperty(i, Q, {
        value: o,
        writable: !0
      }), i;
    },
    S: function S(t, r, o) {
      o ? n(r) && r[Q].A === t && e(t.p) : (t.u && function t(n) {
        if (n && "object" == _typeof(n)) {
          var r = n[Q];

          if (r) {
            var e = r.t,
                o = r.k,
                f = r.D,
                c = r.i;
            if (4 === c) i(o, function (n) {
              n !== Q && (void 0 !== e[n] || u(e, n) ? f[n] || t(o[n]) : (f[n] = !0, k(r)));
            }), i(e, function (t) {
              void 0 !== o[t] || u(o, t) || (f[t] = !1, k(r));
            });else if (5 === c) {
              if (a(r) && (k(r), f.length = !0), o.length < e.length) for (var s = o.length; s < e.length; s++) {
                f[s] = !1;
              } else for (var v = e.length; v < o.length; v++) {
                f[v] = !0;
              }

              for (var p = Math.min(o.length, e.length), l = 0; l < p; l++) {
                void 0 === f[l] && t(o[l]);
              }
            }
          }
        }
      }(t.p[0]), e(t.p));
    },
    K: function K(t) {
      return 4 === t.i ? o(t) : a(t);
    }
  });
}

function F() {
  function e(t) {
    if (!r(t)) return t;
    if (Array.isArray(t)) return t.map(e);
    if (s(t)) return new Map(Array.from(t.entries()).map(function (t) {
      return [t[0], e(t[1])];
    }));
    if (v(t)) return new Set(Array.from(t).map(e));
    var n = Object.create(Object.getPrototypeOf(t));

    for (var i in t) {
      n[i] = e(t[i]);
    }

    return n;
  }

  function f(t) {
    return n(t) ? e(t) : t;
  }

  var c = "add";
  m("Patches", {
    $: function $(n, r) {
      return r.forEach(function (r) {
        for (var i = r.path, u = r.op, f = n, s = 0; s < i.length - 1; s++) {
          var v = o(f),
              p = i[s];
          0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || t(24), "function" == typeof f && "prototype" === p && t(24), "object" != _typeof(f = a(f, p)) && t(15, i.join("/"));
        }

        var l = o(f),
            d = e(r.value),
            h = i[i.length - 1];

        switch (u) {
          case "replace":
            switch (l) {
              case 2:
                return f.set(h, d);

              case 3:
                t(16);

              default:
                return f[h] = d;
            }

          case c:
            switch (l) {
              case 1:
                return f.splice(h, 0, d);

              case 2:
                return f.set(h, d);

              case 3:
                return f.add(d);

              default:
                return f[h] = d;
            }

          case "remove":
            switch (l) {
              case 1:
                return f.splice(h, 1);

              case 2:
                return f.delete(h);

              case 3:
                return f.delete(r.value);

              default:
                return delete f[h];
            }

          default:
            t(17, u);
        }
      }), n;
    },
    R: function R(t, n, r, e) {
      switch (t.i) {
        case 0:
        case 4:
        case 2:
          return function (t, n, r, e) {
            var o = t.t,
                s = t.o;
            i(t.D, function (t, i) {
              var v = a(o, t),
                  p = a(s, t),
                  l = i ? u(o, t) ? "replace" : c : "remove";

              if (v !== p || "replace" !== l) {
                var d = n.concat(t);
                r.push("remove" === l ? {
                  op: l,
                  path: d
                } : {
                  op: l,
                  path: d,
                  value: p
                }), e.push(l === c ? {
                  op: "remove",
                  path: d
                } : "remove" === l ? {
                  op: c,
                  path: d,
                  value: f(v)
                } : {
                  op: "replace",
                  path: d,
                  value: f(v)
                });
              }
            });
          }(t, n, r, e);

        case 5:
        case 1:
          return function (t, n, r, e) {
            var i = t.t,
                o = t.D,
                u = t.o;

            if (u.length < i.length) {
              var a = [u, i];
              i = a[0], u = a[1];
              var s = [e, r];
              r = s[0], e = s[1];
            }

            for (var v = 0; v < i.length; v++) {
              if (o[v] && u[v] !== i[v]) {
                var p = n.concat([v]);
                r.push({
                  op: "replace",
                  path: p,
                  value: f(u[v])
                }), e.push({
                  op: "replace",
                  path: p,
                  value: f(i[v])
                });
              }
            }

            for (var l = i.length; l < u.length; l++) {
              var d = n.concat([l]);
              r.push({
                op: c,
                path: d,
                value: f(u[l])
              });
            }

            i.length < u.length && e.push({
              op: "replace",
              path: n.concat(["length"]),
              value: i.length
            });
          }(t, n, r, e);

        case 3:
          return function (t, n, r, e) {
            var i = t.t,
                o = t.o,
                u = 0;
            i.forEach(function (t) {
              if (!o.has(t)) {
                var i = n.concat([u]);
                r.push({
                  op: "remove",
                  path: i,
                  value: t
                }), e.unshift({
                  op: c,
                  path: i,
                  value: t
                });
              }

              u++;
            }), u = 0, o.forEach(function (t) {
              if (!i.has(t)) {
                var o = n.concat([u]);
                r.push({
                  op: c,
                  path: o,
                  value: t
                }), e.unshift({
                  op: "remove",
                  path: o,
                  value: t
                });
              }

              u++;
            });
          }(t, n, r, e);
      }
    },
    M: function M(t, n, r, e) {
      r.push({
        op: "replace",
        path: [],
        value: n
      }), e.push({
        op: "replace",
        path: [],
        value: t.t
      });
    }
  });
}

function C() {
  function n(t, n) {
    function r() {
      this.constructor = t;
    }

    _a(t, n), t.prototype = (r.prototype = n.prototype, new r());
  }

  function e(t) {
    t.o || (t.D = new Map(), t.o = new Map(t.t));
  }

  function o(t) {
    t.o || (t.o = new Set(), t.t.forEach(function (n) {
      if (r(n)) {
        var e = R(t.A.h, n, t);
        t.p.set(n, e), t.o.add(e);
      } else t.o.add(n);
    }));
  }

  function u(n) {
    n.g && t(3, JSON.stringify(p(n)));
  }

  var _a = function a(t, n) {
    return (_a = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, n) {
      t.__proto__ = n;
    } || function (t, n) {
      for (var r in n) {
        n.hasOwnProperty(r) && (t[r] = n[r]);
      }
    })(t, n);
  },
      f = function () {
    function t(t, n) {
      return this[Q] = {
        i: 2,
        l: n,
        A: n ? n.A : _(),
        P: !1,
        I: !1,
        o: void 0,
        D: void 0,
        t: t,
        k: this,
        C: !1,
        g: !1
      }, this;
    }

    n(t, Map);
    var o = t.prototype;
    return Object.defineProperty(o, "size", {
      get: function get() {
        return p(this[Q]).size;
      }
    }), o.has = function (t) {
      return p(this[Q]).has(t);
    }, o.set = function (t, n) {
      var r = this[Q];
      return u(r), p(r).has(t) && p(r).get(t) === n || (e(r), k(r), r.D.set(t, !0), r.o.set(t, n), r.D.set(t, !0)), this;
    }, o.delete = function (t) {
      if (!this.has(t)) return !1;
      var n = this[Q];
      return u(n), e(n), k(n), n.D.set(t, !1), n.o.delete(t), !0;
    }, o.clear = function () {
      var t = this[Q];
      u(t), p(t).size && (e(t), k(t), t.D = new Map(), i(t.t, function (n) {
        t.D.set(n, !1);
      }), t.o.clear());
    }, o.forEach = function (t, n) {
      var r = this;
      p(this[Q]).forEach(function (e, i) {
        t.call(n, r.get(i), i, r);
      });
    }, o.get = function (t) {
      var n = this[Q];
      u(n);
      var i = p(n).get(t);
      if (n.I || !r(i)) return i;
      if (i !== n.t.get(t)) return i;
      var o = R(n.A.h, i, n);
      return e(n), n.o.set(t, o), o;
    }, o.keys = function () {
      return p(this[Q]).keys();
    }, o.values = function () {
      var t,
          n = this,
          r = this.keys();
      return (t = {})[V] = function () {
        return n.values();
      }, t.next = function () {
        var t = r.next();
        return t.done ? t : {
          done: !1,
          value: n.get(t.value)
        };
      }, t;
    }, o.entries = function () {
      var t,
          n = this,
          r = this.keys();
      return (t = {})[V] = function () {
        return n.entries();
      }, t.next = function () {
        var t = r.next();
        if (t.done) return t;
        var e = n.get(t.value);
        return {
          done: !1,
          value: [t.value, e]
        };
      }, t;
    }, o[V] = function () {
      return this.entries();
    }, t;
  }(),
      c = function () {
    function t(t, n) {
      return this[Q] = {
        i: 3,
        l: n,
        A: n ? n.A : _(),
        P: !1,
        I: !1,
        o: void 0,
        t: t,
        k: this,
        p: new Map(),
        g: !1,
        C: !1
      }, this;
    }

    n(t, Set);
    var r = t.prototype;
    return Object.defineProperty(r, "size", {
      get: function get() {
        return p(this[Q]).size;
      }
    }), r.has = function (t) {
      var n = this[Q];
      return u(n), n.o ? !!n.o.has(t) || !(!n.p.has(t) || !n.o.has(n.p.get(t))) : n.t.has(t);
    }, r.add = function (t) {
      var n = this[Q];
      return u(n), this.has(t) || (o(n), k(n), n.o.add(t)), this;
    }, r.delete = function (t) {
      if (!this.has(t)) return !1;
      var n = this[Q];
      return u(n), o(n), k(n), n.o.delete(t) || !!n.p.has(t) && n.o.delete(n.p.get(t));
    }, r.clear = function () {
      var t = this[Q];
      u(t), p(t).size && (o(t), k(t), t.o.clear());
    }, r.values = function () {
      var t = this[Q];
      return u(t), o(t), t.o.values();
    }, r.entries = function () {
      var t = this[Q];
      return u(t), o(t), t.o.entries();
    }, r.keys = function () {
      return this.values();
    }, r[V] = function () {
      return this.values();
    }, r.forEach = function (t, n) {
      for (var r = this.values(), e = r.next(); !e.done;) {
        t.call(n, e.value, e.value, this), e = r.next();
      }
    }, t;
  }();

  m("MapSet", {
    T: function T(t, n) {
      return new f(t, n);
    },
    F: function F(t, n) {
      return new c(t, n);
    }
  });
}

function J() {
  T(), C(), F();
}

function K(t) {
  return t;
}

function $(t) {
  return t;
}

var G,
    U,
    W = "undefined" != typeof Symbol && "symbol" == _typeof(Symbol("x")),
    X = "undefined" != typeof Map,
    q = "undefined" != typeof Set,
    B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect,
    H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G),
    L = W ? Symbol.for("immer-draftable") : "__$immer_draftable",
    Q = W ? Symbol.for("immer-state") : "__$immer_state",
    V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator",
    Y = {
  0: "Illegal state",
  1: "Immer drafts cannot have computed properties",
  2: "This object has been frozen and should not be mutated",
  3: function _(t) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + t;
  },
  4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  5: "Immer forbids circular references",
  6: "The first or second argument to `produce` must be a function",
  7: "The third argument to `produce` must be a function or undefined",
  8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
  10: "The given draft is already finalized",
  11: "Object.defineProperty() cannot be used on an Immer draft",
  12: "Object.setPrototypeOf() cannot be used on an Immer draft",
  13: "Immer only supports deleting array indices",
  14: "Immer only supports setting array indices and the 'length' property",
  15: function _(t) {
    return "Cannot apply patch, path doesn't resolve: " + t;
  },
  16: 'Sets cannot have "replace" patches.',
  17: function _(t) {
    return "Unsupported patch operation: " + t;
  },
  18: function _(t) {
    return "The plugin for '" + t + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + t + "()` when initializing your application.";
  },
  20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
  21: function _(t) {
    return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + t + "'";
  },
  22: function _(t) {
    return "'current' expects a draft, got: " + t;
  },
  23: function _(t) {
    return "'original' expects a draft, got: " + t;
  },
  24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
},
    Z = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function (t) {
  return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
} : Object.getOwnPropertyNames,
    tt = Object.getOwnPropertyDescriptors || function (t) {
  var n = {};
  return Z(t).forEach(function (r) {
    n[r] = Object.getOwnPropertyDescriptor(t, r);
  }), n;
},
    nt = {},
    rt = {
  get: function get(t, n) {
    if (n === Q) return t;
    var e = p(t);
    if (!u(e, n)) return function (t, n, r) {
      var e,
          i = I(n, r);
      return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(t.k) : void 0;
    }(t, e, n);
    var i = e[n];
    return t.I || !r(i) ? i : i === z(t.t, n) ? (E(t), t.o[n] = R(t.A.h, i, t)) : i;
  },
  has: function has(t, n) {
    return n in p(t);
  },
  ownKeys: function ownKeys(t) {
    return Reflect.ownKeys(p(t));
  },
  set: function set(t, n, r) {
    var e = I(p(t), n);
    if (null == e ? void 0 : e.set) return e.set.call(t.k, r), !0;

    if (!t.P) {
      var i = z(p(t), n),
          o = null == i ? void 0 : i[Q];
      if (o && o.t === r) return t.o[n] = r, t.D[n] = !1, !0;
      if (c(r, i) && (void 0 !== r || u(t.t, n))) return !0;
      E(t), k(t);
    }

    return t.o[n] = r, t.D[n] = !0, !0;
  },
  deleteProperty: function deleteProperty(t, n) {
    return void 0 !== z(t.t, n) || n in t.t ? (t.D[n] = !1, E(t), k(t)) : delete t.D[n], t.o && delete t.o[n], !0;
  },
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(t, n) {
    var r = p(t),
        e = Reflect.getOwnPropertyDescriptor(r, n);
    return e ? {
      writable: !0,
      configurable: 1 !== t.i || "length" !== n,
      enumerable: e.enumerable,
      value: r[n]
    } : e;
  },
  defineProperty: function defineProperty() {
    t(11);
  },
  getPrototypeOf: function getPrototypeOf(t) {
    return Object.getPrototypeOf(t.t);
  },
  setPrototypeOf: function setPrototypeOf() {
    t(12);
  }
},
    et = {};

i(rt, function (t, n) {
  et[t] = function () {
    return arguments[0] = arguments[0][0], n.apply(this, arguments);
  };
}), et.deleteProperty = function (n, r) {
  return "production" !== process.env.NODE_ENV && isNaN(parseInt(r)) && t(13), rt.deleteProperty.call(this, n[0], r);
}, et.set = function (n, r, e) {
  return "production" !== process.env.NODE_ENV && "length" !== r && isNaN(parseInt(r)) && t(14), rt.set.call(this, n[0], r, e, n[0]);
};

var it = function () {
  function e(t) {
    this.O = B, this.N = !0, "boolean" == typeof (null == t ? void 0 : t.useProxies) && this.setUseProxies(t.useProxies), "boolean" == typeof (null == t ? void 0 : t.autoFreeze) && this.setAutoFreeze(t.autoFreeze), this.produce = this.produce.bind(this), this.produceWithPatches = this.produceWithPatches.bind(this);
  }

  var i = e.prototype;
  return i.produce = function (n, e, i) {
    if ("function" == typeof n && "function" != typeof e) {
      var o = e;
      e = n;
      var u = this;
      return function (t) {
        var n = this;
        void 0 === t && (t = o);

        for (var r = arguments.length, i = Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++) {
          i[a - 1] = arguments[a];
        }

        return u.produce(t, function (t) {
          var r;
          return (r = e).call.apply(r, [n, t].concat(i));
        });
      };
    }

    var a;

    if ("function" != typeof e && t(6), void 0 !== i && "function" != typeof i && t(7), r(n)) {
      var f = O(this),
          c = R(this, n, void 0),
          s = !0;

      try {
        a = e(c), s = !1;
      } finally {
        s ? g(f) : w(f);
      }

      return "undefined" != typeof Promise && a instanceof Promise ? a.then(function (t) {
        return j(f, i), P(t, f);
      }, function (t) {
        throw g(f), t;
      }) : (j(f, i), P(a, f));
    }

    if (!n || "object" != _typeof(n)) {
      if ((a = e(n)) === H) return;
      return void 0 === a && (a = n), this.N && d(a, !0), a;
    }

    t(21, n);
  }, i.produceWithPatches = function (t, n) {
    var r,
        e,
        i = this;
    return "function" == typeof t ? function (n) {
      for (var r = arguments.length, e = Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) {
        e[o - 1] = arguments[o];
      }

      return i.produceWithPatches(n, function (n) {
        return t.apply(void 0, [n].concat(e));
      });
    } : [this.produce(t, n, function (t, n) {
      r = t, e = n;
    }), r, e];
  }, i.createDraft = function (e) {
    r(e) || t(8), n(e) && (e = D(e));
    var i = O(this),
        o = R(this, e, void 0);
    return o[Q].C = !0, w(i), o;
  }, i.finishDraft = function (n, r) {
    var e = n && n[Q];
    "production" !== process.env.NODE_ENV && (e && e.C || t(9), e.I && t(10));
    var i = e.A;
    return j(i, r), P(void 0, i);
  }, i.setAutoFreeze = function (t) {
    this.N = t;
  }, i.setUseProxies = function (n) {
    n && !B && t(20), this.O = n;
  }, i.applyPatches = function (t, r) {
    var e;

    for (e = r.length - 1; e >= 0; e--) {
      var i = r[e];

      if (0 === i.path.length && "replace" === i.op) {
        t = i.value;
        break;
      }
    }

    var o = b("Patches").$;
    return n(t) ? o(t, r) : this.produce(t, function (t) {
      return o(t, r.slice(e + 1));
    });
  }, e;
}(),
    ot = new it(),
    ut = ot.produce,
    at = ot.produceWithPatches.bind(ot),
    ft = ot.setAutoFreeze.bind(ot),
    ct = ot.setUseProxies.bind(ot),
    st = ot.applyPatches.bind(ot),
    vt = ot.createDraft.bind(ot),
    pt = ot.finishDraft.bind(ot);

export default ut;
export { it as Immer, st as applyPatches, K as castDraft, $ as castImmutable, vt as createDraft, D as current, J as enableAllPlugins, T as enableES5, C as enableMapSet, F as enablePatches, pt as finishDraft, d as freeze, L as immerable, n as isDraft, r as isDraftable, H as nothing, e as original, ut as produce, at as produceWithPatches, ft as setAutoFreeze, ct as setUseProxies };